export default __webpack_public_path__ + "src/assets/images/banner_two.jpg?296c5d2e";